<template>
    <div class="form-content">
        <!-- 微信认证组件 -->
        <wxAuth :share="share"></wxAuth>
        <!-- title -->
        <headers :params="hraderP"></headers>
        <van-row class="form-item-row" @click="showTypePop">
          <van-col :span="6" class="title">项目业态</van-col>
          <van-col :span="18" class="value arrow-span">
              <input type="text" v-if="!selectedFirstType.text" maxlength="30" placeholder="请选择项目业态" readonly="readonly">
              <input type="text" v-else :value="selectedFirstType.text+`>`+selectedSecondType.text" readonly="readonly" maxlength="30" placeholder="请选择项目业态">
              <van-icon name="arrow" class="arrow-btn"/></van-col>
        </van-row>
        <van-row class="form-item-row" v-if="this.query.firstBuildingType">
          <van-col :span="6" class="title">选择系统</van-col>
          <van-col :span="18" class="value arrow-span" @click="showSystem = true">
            <input type="text" placeholder="请选择所关联的系统" @click="showSystem = true" readonly="readonly">
            <p class="item-box" v-if="selectedSystem.length"><span class="system" v-for="item in selectedSystem" :key="item.id" >{{item.name}}</span></p>
            <span class="item-limit" v-if="selectedSystem.length>0">等{{selectedSystem.length}}个系统</span>
            <van-icon name="arrow" class="arrow-btn"/>
            <dropCheckbox :params="systemList" :showMenus="showSystem" @parentData="systemType"></dropCheckbox>
          </van-col>
        </van-row>
         <van-row class="form-item-row" @click="showStagePop">
          <van-col :span="6" class="title">项目阶段</van-col>
          <van-col :span="18" class="value arrow-span"><input type="text" v-model="selectedStage.text" readonly="readonly" maxlength="30" placeholder="请选择项目阶段"><van-icon name="arrow" class="arrow-btn"/></van-col>
        </van-row>
        <van-row class="project-stage-wrap" v-if="query.projectStage">
          <van-col span="24" v-if="query.projectStage === 1">*方案设计阶段交付成果类型：文字方案（DOC文件）、汇报方案（PPT文件）、根据建筑面积计算的系统估算清单（XLS文件）。</van-col>
          <van-col span="24" v-if="query.projectStage === 2">*初步设计阶段交付成果类型：文字方案（DOC文件）、汇报方案（PPT文件）、不含管线桥架设计的设备点位平面布置图及系统示意图（DWG文件）、根据建筑面积或点位布置图计算系统估算或概算清单（XLS文件）。</van-col>
          <van-col span="24" v-if="query.projectStage === 3">*施工图设计阶段交付成果类型：文字方案（DOC）、汇报方案（PPT文件）、基于甲方提供的设计院施工图（和二次装修图）设计的整套智能化专项设计图纸、根据施工图阶段设计的图纸统计的系统预算清单（XLS文件，客户特殊要求的另外满足）。</van-col>
          <van-col span="24" v-if="query.projectStage === 4">*深化设计阶段交付成果类型：根据项目实际进度提供所需的满足现场施工要求的各类图纸（DWG文件）、配置清单（XLS文件，客户特殊要求的另外满足）等等。</van-col>
        </van-row>
        <van-row class="form-item-row">
          <van-col :span="6" class="title">项目面积</van-col>
          <van-col :span="18" class="value"><input v-model="query.area" oninput="value=(value.replace(/[^\d]/g,'')).slice(0,9)" placeholder="请填写项目面积" maxlength="7"><span class="company-item">平方米</span></van-col>
        </van-row>
        <van-row class="form-item-row" @click="callExpectTime" v-if="query.projectStage === 1 || query.projectStage === 2">
          <van-col :span="6" class="title">交稿时间</van-col>
          <van-col :span="18" class="value arrow-span"><input type="text" :value="query.expectTime.substring(0, 10)" readonly="readonly" maxlength="30" placeholder="请选择交稿时间"><van-icon name="arrow" class="arrow-btn"/></van-col>
        </van-row>
        <div class="bottom-style"></div>
        <van-row class="form-item-button">
          <van-col :span="24"><button @click="submitDemand">立即查询</button></van-col>
        </van-row>
        <van-popup v-model="isShowTypePop"  position="bottom" :style="{ height: '40%' }" >
            <van-picker v-if="isShowTypePop" show-toolbar :columns="typeList" @cancel="onTypeCancel" @confirm="onTypeConfirm" @change="onTypeChange" :item-height="35" />
        </van-popup>
        <van-popup v-model="isShowStagePop"  position="bottom" :style="{ height: '40%' }" >
            <van-picker
                show-toolbar
                v-if="isShowStagePop"
                :columns="stageList"
                @confirm="onStageConfirm"
                @cancel="onStageCancel"
                :default-index="selectedStage.index"
            />
        </van-popup>
        <dateTimePlug v-show="isShowExpectTime" :params="expectTime" @confirm="confirmExpectTime" @cancel="cancelExpectTime"></dateTimePlug>
    </div>
</template>

<script>
import dropCheckbox from '@/components/dropCheckbox'

import headers from '@/components/headers'
import dateTimePlug from '@/components/datetime'
import { dateFormat } from '@/filters/commonFilters'
import wxAuth from '@/components/wxAuth'
import {queryFirstType, querySecondType, querySystemType} from '@/api/demands/demand'
import {offerForm} from '@/api/offerForm/offerForm'
import { toLogin } from '@/utils/common'
import { Row, Col, Checkbox, CheckboxGroup, RadioGroup, Radio, Toast, Notify, Popup } from 'vant'
import { mapState } from 'vuex'
export default {
  name: 'add-demand-form',
  components: { Row, Col, Checkbox, CheckboxGroup, RadioGroup, dateTimePlug, Radio, Toast, Notify, wxAuth, headers, dropCheckbox, Popup },
  computed: {
    ...mapState({
      API2DomainUrl: state => state.baseData.API2DomainUrl,
      token: state => state.user.ticket,
      userId: state => state.user.AccountId,
      userName: state => state.user.AccountName
    })
  },
  data () {
    return {
      share: {
        title: '设计报价器',
        desc: '智能化设计报价器，1秒获取最精准的设计报价',
        imgUrl: 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
        url: window.location.href.split('#')[0]
      },
      hraderP: {
        title: '设计报价器',
        lefticon: true
      },
      isShowTypePop: false,
      isShowStagePop: false,
      isShowExpectTime: false,
      showSystem: false,
      typeList: [
        {
          values: '',
          className: 'column1',
          defaultIndex: 0
        }
      ],
      selectedFirstType: {
        text: '',
        code: null
      },
      selectedSecondType: {
        text: '',
        code: null
      },
      stageList: [
        {
          text: '方案设计',
          code: 1
        },
        {
          text: '初步设计',
          code: 2
        },
        {
          text: '施工图',
          code: 3
        },
        {
          text: '深化设计',
          code: 4
        }
      ],
      selectedStage: {
        text: '',
        code: null,
        index: 0
      },
      date: new Date(),
      expectTime: {
        type: 'date',
        confirm: 'confirm',
        cancel: 'cancel',
        minDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
      },
      systemList: [],
      selectedSystem: [],
      query: {
        firstBuildingType: '', // 一级业态属性
        secondBuildingType: '', // 二级业态属性ID,逗号分割
        projectStage: '', // 项目阶段 方案设计1 施工图2 深化设计3 初步设计4
        sysAttr: [], // 系统属性,逗号分割
        area: null, // 项目面积
        expectTime: '', // 交付时间
        source: '2'// 提交来源 1pc 2m站
      }
    }
  },
  created () {
    this.$store.dispatch('USER_GET_INFO')
  },
  methods: {
    onTypeChange (picker, values, index) {
      var indexs = picker.getIndexes()
      // console.log(indexs)
      if (index === 0) {
        this.query.firstBuildingType = values[0].code
        this.typeList[0].defaultIndex = indexs[0]
        this.typeList[1].defaultIndex = 0
        this.getSecondType()
        this.getSystemType()
        var option = {
          values: [],
          className: 'column2',
          defaultIndex: 0
        }
        if (this.typeList.length === 1) {
          this.typeList.push(option)
        }
      } else {
        this.typeList[1].defaultIndex = indexs[1]
      }
    },
    showTypePop () {
      // if (this.typeList.length === 2) {
      //   this.typeList.pop()
      // }
      this.getFirstType()
      this.isShowTypePop = true
    },
    onTypeConfirm (val, a) {
      this.selectedFirstType = val[0]
      this.selectedSecondType = val[1]
      this.query.firstBuildingType = val[0].code
      this.query.secondBuildingType = val[1].code
      this.isShowTypePop = false
      this.getSystemType()
    },
    onTypeCancel () {
      this.isShowTypePop = false
    },
    showStagePop () {
      this.isShowStagePop = true
    },
    onStageConfirm (val, a) {
      this.selectedStage = val
      this.selectedStage.index = a
      this.query.projectStage = val['code']
      this.isShowStagePop = false
    },
    onStageCancel () {
      this.isShowStagePop = false
    },
    callExpectTime () {
      this.isShowExpectTime = true
    },
    confirmExpectTime (event) {
      this.query.expectTime = dateFormat(event, 'yyyy-MM-dd hh:ss:mm')
      console.log(this.query.expectTime)
      this.isShowExpectTime = false
    },
    cancelExpectTime () {
      this.isShowExpectTime = false
    },
    systemType (data) {
      this.showSystem = false
      this.selectedSystem = data
      var systemArr = data.map(item => {
        return item.id
      })
      this.query.sysAttr = systemArr.join(',')
    },
    // 获取一级业态列表
    getFirstType () {
      queryFirstType()
        .then(result => {
          if (result.status === 200 && result.data && result.data.data) {
            this.typeList[0].values = Object.values(result.data.data.requireTypeSysDataList).map(function (e) {
              return {text: e.name, code: e.id}
            })
            var option = {
              values: [],
              className: 'column2',
              defaultIndex: 0
            }
            if (this.typeList.length === 1) {
              this.typeList.push(option)
            }
            this.getSecondType(this.query.firstBuildingType || this.typeList[0].values[0].code)
          }
        })
        .catch(err => {
          console.log(err)
          // ignore
        })
    },
    // 获取二级业态列表
    getSecondType (code) {
      let params = {
        parentId: code || this.query.firstBuildingType
      }
      querySecondType(params)
        .then(result => {
          console.log(result)
          if (result.status === 200 && result.data && result.data.data) {
            this.typeList[1].values = Object.values(result.data.data.requireTypeSysDataList).map(function (e) {
              return {text: e.name, code: e.id}
            })
          }
        })
        .catch(err => {
          console.log(err)
          // ignore
        })
    },
    // 获取系统列表
    getSystemType () {
      let params = {
        typeId: this.query.firstBuildingType
      }
      querySystemType(params)
        .then(result => {
          if (result.status === 200 && result.data && result.data.data) {
            this.systemList = result.data.data.requireTypeSysDataList
          }
        })
        .catch(err => {
          console.log(err)
          // ignore
        })
    },
    submitDemand () {
      // this.form.userId = this.userId
      // this.form.userName = this.userName
      // this.form.source = 4
      if (!this.userId) {
        toLogin()
        return
      }
      this.query.userId = this.userId
      this.query.userName = this.userName
      if (!this.query.firstBuildingType || this.query.firstBuildingType === '') {
        Toast('请选择项目业态')
        return
      }
      if (!this.query.secondBuildingType || this.query.secondBuildingType === '') {
        Toast('请选择项目业态')
        return
      }

      if (this.query.firstBuildingType) {
        if (!this.query.sysAttr.length) {
          Toast('请选择所关联的系统')
          return
        }
      }
      if (!this.query.projectStage || this.query.projectStage === '') {
        Toast('请选择项目阶段')
        return
      }
      if (!this.query.area || this.query.area === '') {
        Toast('请填写项目面积')
        return
      }
      if (this.query.area && this.query.area.length > 7) {
        Toast('项目面积不能超过7位')
        return
      }
      if (this.query.projectStage === 1 || this.query.projectStage === 2) {
        if (!this.query.expectTime || this.query.expectTime === '') {
          Toast('请选择交稿时间')
          return
        }
      }
      offerForm(this.query).then(result => {
        console.log(result)
        if (result.status === 200) {
          if (result.data && result.data.respCode === '0000') {
            console.log(result)
            this.$router.push(`/offerForm/result.html/${result.data.data.id}/${result.data.data.budget}/${this.query.projectStage}`)
          } else {
            result.data.respDesc ? Notify(result.data.respDesc) : Notify('提交失败')
          }
        } else {
          Notify('提交失败')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-content{
  .form-item{
    &-row{
        border-top: 1px solid #e5e5e5;
        background-color: white;
      .title{
        height: 44px;
        line-height: 44px;
        padding-left: 3%;
        padding-right: 3%;
        font-size: 17px;
        color: #000000;
      }
      .value{

        height: 44px;
        line-height: 44px;
        padding-left: 0;
        padding-right: 3%;
        input{
          width: 92%;
          font-size: 0.426667rem;
          border: none;
          overflow: hidden;
          text-overflow: ellipsis;
          display: inline-block;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
      .checkbox-row{
        padding-left: 3%;
        color: #000000;
        font-size: 17px;
        background-color: white;
        &-item{
          height: 44px;
          line-height: 44px;
          border-bottom: 1px solid #e5e5e5;
           &:last-child{
              border-bottom: none;
            }
         }
      }
     }
    &-button {
      width: 100%;
      position: fixed;
      bottom: 20px;
      button {
        display: block;
        width: 90%;
        margin: 0 auto;
        border: none;
        height: 40px;
        background-color: #007CFF;
        color: white;
        font-size: 18px;
      }
    }
  }
  .project-stage-wrap{
    font-size:12px;
    color:#AFAFB4;
    padding: 15px;

  }
}
  .bottom-style {
    height: 50px;
    width: 100%;
  }
  .company-item{
    position: absolute;
    right: 10px;
  }
  .arrow-span{
    position: relative;
    .item-box{
      width: 61%;
      height: 100%;
      background-color: #ffffff;
      position: absolute;
      left: 0;
      bottom: 0;
      overflow: hidden;
      padding-left: 10px;
      .system{
        display: inline-block;
        color: #409EFF;
        border: 1px solid #409EFF;
        border-radius: 4px;
        padding: 2px 4px;
        height: 20px;
        line-height: 20px;
        margin: 0 4px;
      }
    }
    .item-limit{
      display: inline-block;
      width: 28%;
      height: 100%;
      position: absolute;
      right: 7%;
      bottom: 0;
      color: #409EFF;
      font-size: 14px;
    }
  }
  .arrow-btn{
    position: absolute;
    bottom: 12px;
    right: 10px;
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/view/offerForm/index.vue